module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-19.99d8c095.png";